import { useState } from 'react';
import produtosUsadosOSService from 'features/estoque/services/produtosUsadosOSService';

/**
 * Hook reutilizável para limpar cache e recarregar dados
 * 
 * @param {string} endpoint - Nome do endpoint (ex: 'oss-estoque', 'produtos-usados-os')
 * @param {Object} params - Parâmetros: {data_inicio?, data_fim?, empresa?}
 * @param {Function} reloadFunction - Função que recarrega os dados após limpar cache
 * @param {Function} onSuccess - Callback opcional chamado em caso de sucesso
 * @param {Function} onError - Callback opcional chamado em caso de erro
 * @returns {Object} { clearCacheAndReload, loading }
 */
const useClearCacheAndReload = (endpoint, params, reloadFunction, onSuccess = null, onError = null) => {
  const [loading, setLoading] = useState(false);
  
  const clearCacheAndReload = async () => {
    if (!endpoint) {
      console.error('❌ Endpoint é obrigatório para limpar cache');
      if (onError) {
        onError('Endpoint é obrigatório para limpar cache');
      }
      return;
    }
    
    if (!reloadFunction || typeof reloadFunction !== 'function') {
      console.error('❌ Função de reload é obrigatória');
      if (onError) {
        onError('Função de reload é obrigatória');
      }
      return;
    }
    
    setLoading(true);
    try {
      // Limpar cache
      const response = await produtosUsadosOSService.limparCacheGenerico(endpoint, params);
      
      // Verificar se a limpeza foi bem-sucedida
      if (response && response.success) {
        const message = 'Dados recarregados com sucesso!';
        
        if (onSuccess) {
          onSuccess(message);
        }
        
        // Recarregar dados
        await reloadFunction();
      } else {
        const errorMsg = response?.message || 'Erro ao recarregar dados';
        if (onError) {
          onError(errorMsg);
        }
      }
    } catch (error) {
      console.error('❌ Erro ao recarregar dados:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Erro ao recarregar dados';
      if (onError) {
        onError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };
  
  return { clearCacheAndReload, loading };
};

export default useClearCacheAndReload;

